import { TextField } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import useGetInvestorsLeanResponse from 'hooks/data/investor/useGetInvestorsLeanResponse';
import { useGetRole } from 'hooks/ui/useGetRole';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type MultiInvestorSelectorProps = {
  onChange: (value: Array<string>) => void;
  error?: boolean;
  helperText?: string;
  value: Array<string>;
  excludeDisabledEmail?: boolean;
};

const MultiInvestorSelector = ({
  onChange,
  error,
  helperText,
  value,
  excludeDisabledEmail,
}: MultiInvestorSelectorProps) => {
  const { isSuperAdmin, firmId } = useGetRole();
  const { data: investors, isFetching } = useGetInvestorsLeanResponse({
    ...(isSuperAdmin ? {} : { firmId }),
    excludeDisabledEmail,
  });

  const options = investors?.map((investor) => ({
    label: `${investor.fullName} (${investor.email})`,
    value: investor._id,
  }));

  return (
    <Autocomplete
      popupIcon={<ExpandMoreIcon color="primary" />}
      multiple
      disabled={isFetching}
      value={value
        .map((investorId) =>
          options?.find((investor) => investor.value === investorId),
        )
        .filter(Boolean)}
      options={options ?? []}
      getOptionKey={(option) => option?.value ?? ''}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={isFetching ? 'Loading...' : 'Select investors'}
          disabled={isFetching}
          error={error}
          helperText={helperText}
        />
      )}
      onChange={(_event, value) => {
        onChange(value.map((investor) => investor?.value ?? ''));
      }}
    />
  );
};

export default MultiInvestorSelector;
